<input
  [formControl]="formControl"
  [style.background-color]="formControl.valid ? 'white' : 'yellow'"
/>
